module.exports = __webpack_public_path__ + "media/images/icons/black-close-ce11fa9f021a07e9938bb8523b573e81.svg";